import { map } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { Principal } from '../../../../shared';

import {
    Trainer,
    TrainerService,
    TrainingService,
    ProfileService,
    GraphQlService,
} from '../../../../_services';
import { TrainerQueryOutput, TrainerSkill } from '../models/trainer.model';

@Component({
    selector: 'trainer-detail-skill',
    templateUrl: './skill.component.html',
    styleUrls: ['../../trainer.component.scss', '../detail.component.scss'],
    providers: [TranslatePipe],
})
export class TrainerDetailSkillComponent implements OnInit {
    @Input() trainer: TrainerQueryOutput;
    currentTrainer: TrainerQueryOutput;
    error: string;
    success: string;
    account: any;
    profile: Trainer;
    time = '';
    items: Array<any> = [];
    selectedTraining: any;
    canEditWishes = false;
    canEditCan = false;
    selectedBox: String = 'wished';
    saving = false;

    constructor(
        private principal: Principal,
        private trainerService: TrainerService,
        private trainingService: TrainingService,
        private profileService: ProfileService,
        private graphQlService: GraphQlService
    ) {}

    ngOnInit() {
        this.currentTrainer = this.trainer;
        this.mapSkills(this.trainer);
        this.loadProfile().then(() => this.checkAuthorization());
    }

    searchTrainings(keyword: string) {
        return this.graphQlService
            .post({
                query: `
                   query($keyword: String!) {
                      trainings: training(
                        where: {
                          _and: [
                            { _or: [{ active: { _eq: true } }, { published: { _eq: true } }] }
                            { deleted: { _eq: false } }
                            { title: { _ilike: $keyword } }
                          ]
                        }
                        order_by: [{ title: asc_nulls_first }]
                      ) {
                        id
                        title
                        reference
                      }
                    }
                `,
                variables: {
                    keyword: `%${keyword}%`,
                },
                role: 'world',
            })
            .pipe(map(({ trainings }) => trainings));
    }

    loadProfile() {
        this.updateTime();
        return this.profileService
            .findCurrent()
            .toPromise()
            .then((profile) => {
                this.profile = profile;
            });
    }

    updateTime() {
        this.time = new Date().getTime().toString();
    }

    checkAuthorization() {
        this.principal.hasAnyAuthority(['ROLE_ADMIN']).then((isAdmin) => {
            this.canEditWishes =
                this.profile &&
                this.profile.email &&
                this.currentTrainer &&
                this.currentTrainer.email &&
                (this.profile.email === this.currentTrainer.email || isAdmin);
        });
        this.principal
            .hasAnyAuthority(['ROLE_RESPONSABLE_PEDAGOGIQUE'])
            .then((isResponsablePedagogique) => {
                this.canEditCan = isResponsablePedagogique;
            });
    }

    addSkill() {
        this.saving = true;
        let found = false;
        for (let i = 0; i < this.currentTrainer.trainerSkills.length; i++) {
            if (
                this.selectedTraining &&
                this.currentTrainer.trainerSkills[i].trainingId ===
                    this.selectedTraining.id
            ) {
                this.currentTrainer.trainerSkills[i].wished =
                    this.selectedBox === 'wished'
                        ? true
                        : this.currentTrainer.trainerSkills[i].wished;
                this.currentTrainer.trainerSkills[i].can =
                    this.selectedBox === 'can'
                        ? true
                        : this.currentTrainer.trainerSkills[i].can;
                this.currentTrainer.trainerSkills[i].refuse =
                    this.selectedBox === 'refuse'
                        ? true
                        : this.currentTrainer.trainerSkills[i].refuse;
                found = true;
                this.trainerService
                    .createSkill(
                        this.currentTrainer.trainerSkills[i],
                        this.currentTrainer.id
                    )
                    .subscribe(null, null, () => {
                        this.saving = false;
                    });
                break;
            }
        }
        if (!found) {
            let skill: TrainerSkill = {
                can: this.selectedBox === 'can',
                followed: false,
                highLight: true,
                nbGiven: 0,
                refuse: this.selectedBox === 'refuse',
                trainerId: this.currentTrainer.id,
                trainingId: this.selectedTraining.id,
                training: {
                    title: this.selectedTraining.title,
                },
                wished: this.selectedBox === 'wished',
            };
            this.trainerService
                .createSkill(skill, this.currentTrainer.id)
                .subscribe(
                    (persistedSkill: TrainerSkill) => {
                        this.items = [...this.items, persistedSkill];
                    },
                    null,
                    () => {
                        this.saving = false;
                    }
                );
        }
    }

    deleteSkill(skill) {
        this.trainerService
            .deleteSkill(skill, this.currentTrainer.id)
            .subscribe();
    }

    myListFormatter(data: any): string {
        let html = '';
        html += data.title
            ? `<span><strong>${data.title}</strong></span>`
            : data;
        html += data.reference ? `<span> (${data.reference})</span>` : data;
        return html;
    }

    private mapSkills(trainer) {
        this.items = [];
        trainer.trainerSkills.map((skill) => {
            skill.highLight = true;
            this.items.push({ ...skill, trainingName: skill.training.title });
        });
    }

    setSelectBox(box: string) {
        if (box === 'can' && !this.canEditCan) {
            return;
        }
        this.selectedBox = box;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/skill/skill.component.ts